import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/inventory/ImportarMinMax',
  documento: 'inventory',
  acceso: 'sesion',
  filas: ['077'],
  cita: 'Areas/Inventory/Controllers/InventoryController.cs:892',
} satisfies RutaProd;
